import styled from 'styled-components';

import { StaticPagesSidebarListingItemViewModel } from '@api/index';
import SidebarItem from '@components/Menu/next/SideBar/SidebarItem';
export const Wrapper = styled.div`
  padding-right: 10px;
  height: 64px;
`;
export type MenuItemEventType = {
  slug?: string;
  path: { title?: string; url?: string }[];
  title?: string;
  links?: boolean;
};

export type SideMenuProps<ItemWrapperProps> = {
  items: StaticPagesSidebarListingItemViewModel[];
  onMenuItemClick?: ({ slug, path, title }: MenuItemEventType) => void;
  staticPageSubPath: string;
  defaultOpenKeys: string[];
  defaultSelectedKeys: string[];
  ItemWrapper?: React.ComponentType<React.PropsWithChildren<ItemWrapperProps>>;
  getItemWrapperProps?: (
    item: Partial<StaticPagesSidebarListingItemViewModel>
  ) => ItemWrapperProps;
};

const SideMenu = <T,>({
  items,
  staticPageSubPath,
  onMenuItemClick,
  defaultOpenKeys,
}: SideMenuProps<T>) => {
  return (
    <>
      {items?.map((item, index) => (
        <>
          {item.links.length > 0 ? (
            <SidebarItem
              key={index}
              item={item}
              onMenuItemClick={onMenuItemClick}
              selected={defaultOpenKeys}
              staticPageSubPath={staticPageSubPath}
            />
          ) : (
            <Wrapper
              onClick={() =>
                onMenuItemClick?.({
                  slug: item.title,
                  path: [{ title: item.title, url: item.slug }],
                  title: item.title,
                  links: item.links.length > 0,
                })
              }
              key={index}
            >
              <SidebarItem
                key={index}
                item={item}
                selected={defaultOpenKeys}
                staticPageSubPath={staticPageSubPath}
              />
            </Wrapper>
          )}
        </>
      ))}
    </>
  );
};

export default SideMenu;
